export default __webpack_public_path__ + "static/media/right_arrow_white.59110171.svg";